import * as React from 'react';
import { Label } from '..';
import { Box } from '../../CommonUI/Layout';
import { StyleSheet, css } from 'aphrodite';
import { ToggleTrackingProps } from '../../Model';

interface ToggleProps {
    onChange?: (value: boolean) => void;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    id?: string;
    checked?: boolean;
    label?: string;
    disabled?: boolean;
    description?: JSX.Element;
    track?: ToggleTrackingProps;
    appearance?: 'bold' | 'subtle';
    mt?: number;
    pl?: number;
}

export const Toggle: React.SFC<ToggleProps> = (props) => {
    const { onChange, onClick, checked, label, id, disabled, appearance = 'subtle', pl = 20 } = props;
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.track) {
            const { source, ...track} = props.track;
            analytics.track('Integration Button Clicked', {
                context: 'Ecommscript integration app',
                location: window.location.pathname,
                integration: source,
                checked: e.target.checked,
                ...track
            });
        }
        if (onChange) {
            onChange(e.target.checked);
        }
    };

    const onClickHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        if (onClick) {
            onClick(e);
        }
    };
    const inputId = id ? id : 'trustbox-toggle';
    let toggleLabel;
    if (label) {
        toggleLabel = (
            <Label
                htmlFor={inputId}
                label={label}
            />
        );
    }
    return (
        <Box mt={props.mt} pl={pl} pr={20}>
            {toggleLabel}
            <label
                className={css(styles.common.switch, styles[appearance].switch)}
                onClick={onClickHandler}
            >
                <input
                    id={inputId}
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={onChangeHandler}
                    className={css(styles.common.input)}
                />
                <span
                    className={css(
                        styles.common.slider,
                        styles[appearance].slider,
                        checked && styles.common.sliderChecked,
                        checked && styles[appearance].sliderChecked,
                        disabled && styles.common.sliderDisabled
                    )}
                />
            </label>
            <div className={css(styles.common.description)}>
                {props.description}
            </div>
        </Box>
    );
};

const styles = {
    common: StyleSheet.create({
        description: {
            display: 'inline-block',
            verticalAlign: 'top',
            marginLeft: '19px',
            marginTop: '4px',
            color: '#a9a9a9'
        },
        input: {
            display: 'none',
        },
        switch: {
            position: 'relative',
            display: 'inline-block',
            cursor: 'pointer',
            borderRadius: '25.6px',
        },
        slider: {
            'position': 'absolute',
            'cursor': 'pointer',
            'top': 0,
            'left': 0,
            'right': 0,
            'bottom': 0,
            'backgroundColor': '#7e7e7e',
            'transition': '.4s',
            'borderRadius': '25.6px',
            ':before': {
                position: 'absolute',
                content: '""',
                backgroundColor: '#ffffff',
                transition: '.4s',
                borderRadius: '50%',
            },
        },
        sliderChecked: {
            backgroundColor: '#368cd7',
        },
        sliderDisabled: {
            backgroundColor: '#d8d8d8',
            cursor: 'not-allowed',
        },
    }),
    bold: StyleSheet.create({
        switch: {
            width: '66px',
            height: '32px',
        },
        slider: {
            ':before': {
                height: '20px',
                width: '20px',
                left: '8px',
                bottom: '6px',
            }
        },
        sliderChecked: {
            ':before': {
                transform: 'translateX(30px)',
            }
        },
    }),
    subtle: StyleSheet.create({
        switch: {
            width: '41px',
            height: '24px',
        },
        slider: {
            ':before': {
                height: '16.4px',
                width: '16.4px',
                left: '4px',
                bottom: '4px',
            }
        },
        sliderChecked: {
            ':before': {
                transform: 'translateX(16.8px)',
            }
        },
    }),
};



// WEBPACK FOOTER //
// ./src/CommonUI/Control/Toggle.tsx